import { render } from "./LiveGamelist.vue?vue&type=template&id=3c7cb1ea&ts=true"
import script from "./LiveGamelist.vue?vue&type=script&lang=ts"
export * from "./LiveGamelist.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__